import { Injectable, ɵɵdefineInjectable, Component, Input, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modal.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ModalService {
    /**
     * @param {?} idModal
     * @param {?=} titulo
     * @return {?}
     */
    ShowModal(idModal, titulo = "") {
        metroDialog.toggle("#" + idModal);
        $(".headerDialog label").html(titulo);
    }
    /**
     * @param {?} idModal
     * @return {?}
     */
    CloseModal(idModal) {
        /** @type {?} */
        var dialog = $("#" + idModal).data('dialog');
        dialog.close();
    }
}
ModalService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */ ModalService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ModalService_Factory() { return new ModalService(); }, token: ModalService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modal.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var chance = require("chance").Chance();
class ModalComponent {
    constructor() {
        this.closeModal = (/**
         * @param {?=} response
         * @return {?}
         */
        (response = true) => {
            /** @type {?} */
            var dialog = $(`#${this.id}`).data("dialog");
            dialog.close();
            /** @type {?} */
            let controls = (/** @type {?} */ ($(".searchModal")));
            /** @type {?} */
            let elementos = null;
            for (let item of controls) {
                /** @type {?} */
                let visible = $(item).css("visibility");
                if (visible == "visible") {
                    elementos = visible;
                }
            }
            if (elementos != "visible") {
                $(`body`).css("overflow-y", "auto");
            }
            this._Response.next(response);
        });
        this.CloseModalFunction = (/**
         * @param {?=} response
         * @return {?}
         */
        (response = true) => {
            this.closeModal(response);
        });
        this.showModal = (/**
         * @param {?=} place
         * @return {?}
         */
        (place = "default") => {
            $(`#${this.id}`).css("width", this.width);
            metroDialog.toggle(`#${this.id}`, place);
            $("body").css("overflow-y", "hidden");
            this._Response = new Subject();
            return this._Response;
        });
        this.getIdClass = (/**
         * @return {?}
         */
        () => {
            this._id = chance.guid();
            this._idContent = chance.guid();
        });
    }
    /**
     * @return {?}
     */
    get id() {
        return this._id;
    }
    /**
     * @return {?}
     */
    get idContent() {
        return this._idContent;
    }
    /**
     * @return {?}
     */
    get opDark() {
        return this._opDark;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.getIdClass();
        this._opDark = "op-dark";
        if (this.height == undefined || this.height == null) {
            this.height = "500px";
        }
        if (this.isContentDinamico == null || this.isContentDinamico == undefined)
            this.isContentDinamico = true;
        if (this.Visible == undefined || this.Visible == null) {
            this.Visible = true;
        }
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (this.draggable) {
            $(`#${this.id}`).attr("data-role", "dialog, draggable"); // draggable
        }
    }
}
ModalComponent.decorators = [
    { type: Component, args: [{
                selector: 'modal-template',
                template: `
<div style="border: 2px solid;z-index: 1999 !important;" data-role="dialog" [attr.id]="id" class="grid searchModal" [attr.data-overlay]="true" 
[attr.data-background]="'#fefefe'" [attr.data-close-button]="false" [attr.data-width]="width" [attr.data-overlay]="true" 
[attr.data-overlay-click-close]="false" [attr.data-overlay-color]="opDark">
    <div class="headerDialog flex-grid">
        <div class="row cells12">
            <div class="sub-header cell colspan10 modalHeaderVesta">
                <label>{{tittle}}</label>
            </div>
            <div class="cell colspan2 modalHeaderVesta">
                <img (click)="closeModal()" [ngStyle]="{ 'visibility': Visible ? 'unset' :'hidden'}" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAADdAAAA3QFwU6IHAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAQtQTFRF////JJLbIIC/IIDKH4XMHILMH4XOH4PPHoTOHoXOHoTOH4XPIITOH4XOH4TNH4TOH4TOH4TOJYfPOJHTOZLUSZrWS5zYZanaaa3edrLdfbjjjLzgjb7hjb7ilsXomMfpsM/mudbswdjpw97y0eDs2eTt2er32uXt2+Xt3Obt3ebt3ebu3efu393l3+jw4d/l4erw4urw48zV5cfQ5e/36O7z6O/z6e/06vD07PT67fL27/b88fX48vX58/b59I+d9Y2b9e3w9ff69fj69oqY9vn79/n7+Pr7+fv8+tzh+3aG+9fc+/3+/I6b/JKf/JSh/f7+/f7//tnd/t/j/v7+/v7///T1//7/////THgr+QAAABF0Uk5TAAcIGBktSYSXmMHI2uPy8/XVqDFbAAAB2klEQVQ4jYVT11YCQQxdEOlVOiIgfaUjRQXpiiwoRcH8/5eYZNgF9HjIw0Bys8nNnYwkaaYzWqx2l8tutRh10l8zmJ0ezZxmwy9Yb3J7Tsxt0h/jFzbPH7NdHPBLB4e8wetEOp24DnrZdVxq3zN+Fc3L8l2tdifL+egVZ+xr6Lm+Pym3utMtwHbabclJP3cRPEz0P5ypvoJmr9VMmKImno/4+3NPWziy7VOOarhpWjP1T3YBvjefAv3cfAN0k8TDjPqRPtEm4h+KstwB7JaK8oEZzSgpppOMNF95BbBR0N53u3f63QCsyjStUbLgGXzBwjOFMxhXZhh4CSJkkax43lDnXl/RrN+jyA1CVsmO5y25X5WJik8qXxS5RcguufBsMPlxaZ8xKY050EDIxQmPYryhmjAU/iMnUIsU+4K/mIUDKW5BJGPsLw8klxyIMUkaM8T6ifKiDWsa4jFJKN8a3bngJ5jOMbD2sVAsdRz95wHOXxqPS6jH4BkDcSG1uKwsSlu8rxdGAKNC/b6I0mf3lyWuO7AAmLYf3qj120N7CrAIqNctFiaygBNbRLSF2a9cIHuMZwNHK6cubXytwuv4ydJqa+8LxVKdTioW8v1a+/MP5/zTO/94/3/+Px4gl/0Dnu+pAAAAAElFTkSuQmCC"/>
            </div>
        </div>
    </div>
    <div [ngClass]="{'contentDialog': isContentDinamico }" style="margin:5px;">
        <div [attr.id]="idContent" class="contentDinamico" style="min-height: 300px;" [ngStyle]="{'height': height}">
            <ng-content></ng-content>
        </div>        
    </div>    
</div>
  `
            }] }
];
/** @nocollapse */
ModalComponent.ctorParameters = () => [];
ModalComponent.propDecorators = {
    tittle: [{ type: Input, args: ["tittle",] }],
    width: [{ type: Input, args: ["width-modal",] }],
    height: [{ type: Input, args: ["height-modal",] }],
    draggable: [{ type: Input, args: ["draggable",] }],
    isContentDinamico: [{ type: Input, args: ["isContentDinamico",] }],
    Visible: [{ type: Input, args: ['close-visible',] }]
};
if (false) {
    /**
     * @type {?}
     * @private
     */
    ModalComponent.prototype._id;
    /**
     * @type {?}
     * @private
     */
    ModalComponent.prototype._idContent;
    /**
     * @type {?}
     * @private
     */
    ModalComponent.prototype._opDark;
    /** @type {?} */
    ModalComponent.prototype.tittle;
    /** @type {?} */
    ModalComponent.prototype.width;
    /** @type {?} */
    ModalComponent.prototype.height;
    /** @type {?} */
    ModalComponent.prototype.draggable;
    /** @type {?} */
    ModalComponent.prototype.isContentDinamico;
    /** @type {?} */
    ModalComponent.prototype.Visible;
    /**
     * @type {?}
     * @private
     */
    ModalComponent.prototype._Response;
    /** @type {?} */
    ModalComponent.prototype.closeModal;
    /** @type {?} */
    ModalComponent.prototype.CloseModalFunction;
    /** @type {?} */
    ModalComponent.prototype.showModal;
    /**
     * @type {?}
     * @private
     */
    ModalComponent.prototype.getIdClass;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modal.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ModalModule {
}
ModalModule.decorators = [
    { type: NgModule, args: [{
                declarations: [ModalComponent],
                imports: [
                    CommonModule
                ],
                exports: [ModalComponent],
                providers: [ModalService]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: modal.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ModalComponent, ModalModule, ModalService };
//# sourceMappingURL=modal.js.map
